{
  "dashboard": {
    "place": {
      "inShift": "اکنون در {{clinic}} · تا {{end}}",
      "between": "شیفت بعدی: {{clinic}} · {{start}}",
      "beforeFirst": "امروز: {{clinic}} از {{start}}",
      "done": "شیفت امروز تمام شد · {{clinic}}",
      "overlap": "هم‌زمان در {{count}} مطب",
      "noShiftToday": "برای امروز ساعت حضور ثبت نشده",
      "noShiftDay": "برای این روز ساعت حضور ثبت نشده",
      "noShiftHint": "ساعات حضور را کلینیک ثبت می‌کند",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "و {{count}} مطب دیگر",
      "aria": "محل کار طبق برنامهٔ حضور"
    },
    "stats": {
      "total": "نوبت",
      "waiting": "منتظر",
      "completed": "انجام",
      "cancelled": "لغو",
      "aria": "{{total}} نوبت، {{waiting}} در انتظار، {{completed}} ویزیت‌شده، {{cancelled}} لغو‌شده",
      "share": "سهم: {{amount}}",
      "shareNoFigure": "سهم"
    },
    "week": {
      "title": "انتخاب روز",
      "thisWeek": "این هفته",
      "nextWeek": "هفتهٔ بعد",
      "prevWeek": "هفتهٔ قبل",
      "range": "{{from}} تا {{to}}",
      "fullCalendar": "تقویم کامل",
      "backToWeek": "بازگشت به هفته",
      "countAria": "{{count}} نوبت"
    },
    "clinic": {
      "auto": "خودکار — طبق برنامهٔ حضور",
      "autoSub": "مطبی که برنامهٔ حضور برای این روز نشان می‌دهد",
      "autoBadge": "خودکار"
    },
    "book": {
      "open": "نوبت جدید",
      "title": "ثبت نوبت",
      "clinic": "کلینیک",
      "patient": "بیمار",
      "searchLabel": "جست‌وجوی بیمار",
      "searchPlaceholder": "نام، شماره تماس یا کد ملی",
      "searchHint": "دست‌کم دو حرف وارد کنید.",
      "noMatch": "بیماری با این مشخصات در فهرست شما نیست.",
      "truncated": "فقط {{count}} نتیجهٔ نخست نمایش داده شد؛ دقیق‌تر جست‌وجو کنید.",
      "newPatient": "بیمار جدید",
      "pickExisting": "انتخاب از بیماران",
      "change": "تغییر",
      "name": "نام و نام خانوادگی",
      "phone": "شماره همراه",
      "nationalId": "کد ملی (اختیاری)",
      "when": "تاریخ و ساعت",
      "duration": "مدت نوبت",
      "minutes": "{{count}} دقیقه",
      "note": "یادداشت (اختیاری)",
      "submit": "ثبت نوبت",
      "submitRequest": "ارسال برای تأیید کلینیک",
      "needsApprovalTitle": "نیازمند تأیید کلینیک",
      "needsApproval": "نوبت‌هایی که در این کلینیک ثبت می‌کنید پس از تأیید پذیرش نهایی می‌شوند و تا آن زمان «در انتظار تأیید کلینیک» می‌مانند.",
      "booked": "نوبت ثبت شد.",
      "requested": "نوبت برای تأیید به کلینیک ارسال شد.",
      "loadFailed": "فهرست کلینیک‌ها بارگذاری نشد.",
      "noClinic": "در حال حاضر در هیچ کلینیکی امکان ثبت نوبت ندارید.",
      "searchFailed": "جست‌وجوی بیمار انجام نشد.",
      "modeFirstDay": "اولین نوبت این روز",
      "modeFirstToday": "اولین نوبت امروز",
      "modeManual": "انتخاب دستی",
      "showTimeOptions": "تغییر روز یا روش انتخاب زمان",
      "hideTimeOptions": "بستن گزینه‌های زمان",
      "noneLeftToday": "نوبت خالی دیگری برای امروز باقی نمانده است.",
      "finding": "در حال یافتن نزدیک‌ترین نوبت…",
      "bookThisOne": "همین را ثبت کن",
      "firstFree": "اولین نوبت خالی",
      "exactAtBooking": "نوبت دقیق هنگام ثبت نهایی می‌شود.",
      "firstSlotFailed": "یافتن اولین نوبت خالی با خطا مواجه شد. می‌توانید زمان را دستی انتخاب کنید.",
      "lessOptions": "بستن گزینه‌های بیشتر",
      "typeInPerson": "حضوری",
      "typeOnline": "غیرحضوری",
      "submitFirst": "ثبت اولین نوبت",
      "walkIn": "خارج از نوبت همین الان",
      "walkInOff": "بیمار همین حالا حاضر است؛ بدون ساعت به صف امروز شما اضافه شود.",
      "walkInOn": "بدون ساعت ثبت می‌شود و بیمار همین حالا به صف امروز شما اضافه می‌شود.",
      "walkInOnShort": "بدون ساعت؛ به صف امروز اضافه می‌شود.",
      "walkInLead": "امروز نوبت خالی ندارید؛ بیمار بدون ساعت، همین حالا به صف امروز شما اضافه شود.",
      "walkInLeadShort": "بدون ساعت، به صف امروز.",
      "walkInNoGrant": "در این کلینیک نوبت‌های شما با تأیید پذیرش ثبت می‌شود؛ بیمار حاضر را پذیرش کلینیک خارج از نوبت ثبت می‌کند.",
      "walkInNoGrantShort": "در این کلینیک فقط پذیرش می‌تواند خارج از نوبت ثبت کند.",
      "alreadyOpen": {
        "scheduled": "این بیمار امروز نوبت دیگری هم دارد که هنوز نیامده است.",
        "arrived": "این بیمار همین حالا در صف امروز است؛ نوبت دوم لازم است؟",
        "in_visit": "این بیمار همین حالا در حال ویزیت است؛ نوبت دوم لازم است؟"
      },
      "submitWalkIn": "ثبت و افزودن به صف",
      "walkInBooked": "بیمار به صف امروز اضافه شد.",
      "mode": "روش انتخاب زمان",
      "day": "روز",
      "visitType": "نوع ویزیت",
      "moreOptions": "گزینه‌های بیشتر (نوع ویزیت، مدت، یادداشت)",
      "noneThisDay": "در این روز نوبت خالی ندارید.",
      "nextIs": "نزدیک‌ترین نوبت خالی شما:",
      "noneIn30Days": "در ۳۰ روز آینده هم نوبت خالی یافت نشد.",
      "slotAt": "{{date}}، ساعت {{time}}",
      "errors": {
        "clinic": "کلینیک را انتخاب کنید.",
        "patient": "بیمار را انتخاب کنید.",
        "name": "نام بیمار را وارد کنید.",
        "phone": "شمارهٔ همراه معتبر نیست.",
        "nationalId": "کد ملی معتبر نیست.",
        "when": "تاریخ و ساعت نوبت را وارد کنید.",
        "past": "این زمان گذشته است.",
        "noSlot": "در این روز نوبت خالی نیست؛ روز دیگری انتخاب کنید یا زمان را دستی وارد کنید."
      }
    },
    "withdraw": {
      "action": "لغو درخواست",
      "title": "لغو درخواست نوبت",
      "message": "درخواست نوبت {{name}} لغو شود؟ این درخواست از فهرست کلینیک حذف می‌شود.",
      "confirm": "لغو درخواست",
      "keep": "انصراف",
      "failed": "لغو درخواست انجام نشد."
    },
    "reschedule": {
      "action": "تغییر زمان",
      "title": "تغییر زمان نوبت",
      "current": "زمان فعلی: {{when}}",
      "newTime": "زمان جدید",
      "hint": "نوبت جابه‌جا می‌شود؛ لغو و دوباره ثبت نمی‌شود، پس فاکتور و پرداخت آن سر جای خود می‌ماند.",
      "submit": "ثبت زمان جدید",
      "moved": "نوبت به {{when}} منتقل شد."
    }
  },
  "nav": {
    "mobile": {
      "more": "بیشتر",
      "moreTitle": "بیشتر",
      "account": "حساب کاربری",
      "sections": "بخش‌ها",
      "balance": "موجودی {{coin}}"
    }
  }
}
